import { paymentSources } from '../constants'

export const isDisabledTerminalTips = (selectedTerminal, orderType) => {
    const paymentSource = paymentSources?.find(item => item.orderType === orderType)?.paymentSource
	return !selectedTerminal?.tipsConfiguration?.find(tc => tc.paymentSource === paymentSource)?.enable
}